/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import { buildImageUrl } from "../theme1/utils/theme1Helpers";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

const HeroSection = ({ theme, apiBanners = [], storeData = {}, onShop }) => {
  const activeBanners = (apiBanners || []).filter((b) => b.active);
  const bannerImages = activeBanners.map((b) => buildImageUrl(b.imageUrl));
  const canLoop = bannerImages.length > 1;

  return (
    <section className="t3-hero" dir="rtl">
      <div className="t3-container">
        {bannerImages.length > 0 ? (
          <Swiper
            modules={[Autoplay, Pagination, Navigation]}
            pagination={{ clickable: true }}
            navigation={bannerImages.length > 1}
            loop={canLoop}
            autoplay={canLoop ? { delay: 3500, disableOnInteraction: false } : false}
            className="t3-hero-swiper"
          >
            {bannerImages.map((img, idx) => (
              <SwiperSlide key={idx}>
                <div className="t3-hero-slide">
                  <img src={img} alt={`banner-${idx}`} />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        ) : (
          <div className="t3-hero-fallback" style={{ background: `linear-gradient(135deg, ${theme.primary} 0%, ${theme.primaryDark} 100%)` }}>
            <div>
              <h1>{storeData.storeName || "أفضل المنتجات، بأبسط تجربة"}</h1>
              <p>{storeData.description || storeData.storeSlogan || "اكتشف منتجات مختارة بعناية، توصيل سريع ودفع عند الاستلام."}</p>
              <button type="button" onClick={onShop}>تسوق الآن</button>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default HeroSection;
